import { useEffect, useMemo, useReducer } from 'react';
import reducer from './reducer';
import {
  filterUnExistedOrgs,
  initFormStateFromDiscoverySetting,
  onChangeGithubOrg,
  onChangeVisibility,
  setExclusionRegex,
  setInclusionRegex,
  setOrgDetectionStrategyRegex,
  switchOrgDetectionStrategy,
  toggleIsActive
} from './actions';
import { REPOS_AUTO_DISCOVERY_STATE_TYPE } from '@linearb/linjs-common';
import { omit } from 'lodash';
import { ORG_DETECTION_STRATEGY } from './formState.types';

const useFormState = integrationDiscoverySetting => {
  const [state, dispatch] = useReducer(reducer, {
    filter: {},
    extra: {}
  });

  const newSettingPayload = useMemo(() => {
    let extra = { ...state.extra };
    if (state.orgDetectionStrategy === ORG_DETECTION_STRATEGY.ORG_SELECTION) {
      extra = omit(extra, 'github_orgs_discovery_regex');
    }
    if (state.orgDetectionStrategy === ORG_DETECTION_STRATEGY.REGEX) {
      extra = omit(extra, 'github_orgs');
    }
    const newSettingPayload = {
      ...state,
      extra
    };

    return newSettingPayload;
  }, [state]);

  useEffect(() => {
    dispatch(initFormStateFromDiscoverySetting(integrationDiscoverySetting));
  }, [integrationDiscoverySetting?.value?.id]);

  return {
    inclusionRegex: state.filter.inclusion_regex,
    setInclusionRegex: str => dispatch(setInclusionRegex(str)),
    exclusionRegex: state.filter.exclusion_regex,
    setExclusionRegex: str => dispatch(setExclusionRegex(str)),
    isActive: state.state === REPOS_AUTO_DISCOVERY_STATE_TYPE.ACTIVE,
    toggleIsActive: () => dispatch(toggleIsActive()),
    selectedGithubOrgs: state.extra.github_orgs || [],
    onChangeGithubOrg: selectedOrgs =>
      dispatch(onChangeGithubOrg(selectedOrgs)),
    filterUnExistedOrgs: githubOrgsNames =>
      dispatch(filterUnExistedOrgs(githubOrgsNames)),
    visibility: state.extra.visibility,
    onChangeVisibility: selectedValues =>
      dispatch(onChangeVisibility(selectedValues)),
    orgDetectionStrategy: state.orgDetectionStrategy,
    switchOrgDetectionStrategy: strategy =>
      dispatch(switchOrgDetectionStrategy(strategy)),
    orgDetectionStrategyRegex: state.extra.github_orgs_discovery_regex,
    setOrgDetectionStrategyRegex: value =>
      dispatch(setOrgDetectionStrategyRegex(value)),
    newSettingPayload
  };
};

export default useFormState;
